import React, { useState, useEffect } from "react";
import { Helmet } from 'react-helmet-async'
import { Container,Grid } from "@mui/material";
import CommonLOVGrid from "../manageLOV/commonLOVGrid";
import { fetchAggregatorHitMappingList } from "../resourceCommonAPIs";

const AggregatorMapping = (props) => {

    const [aggregatorHITMappingArr, setAggregatorHITMappingArr] = useState([]);
    const [aggregatorIdHITSelected, setAggregatorIdHITSelected] = useState();

    useEffect(() => {
        fetchAggregatorHitMappingList(setAggregatorHITMappingArr);
    }, [])

    return (
        <>
            <Helmet>
                <title> Home | ABEPL </title>
            </Helmet>
            <Container maxWidth="xxl">
                <Grid item xs={12} lg={12}>
                    <CommonLOVGrid arr={aggregatorHITMappingArr} setArr={setAggregatorHITMappingArr} selectedRow={aggregatorIdHITSelected} setSelectedRow={setAggregatorIdHITSelected} lovType="aggregatorHitMapping" lovText="Mapping" setAggregatorHITMappingArr={setAggregatorHITMappingArr} />
                </Grid>
            </Container>

        </>
    );
};
export default AggregatorMapping;
